import * as AnalyticsAPI from 'api/analytics.api.js'

module.exports = {
  fetchCoachName: (coachOrgId) => async (dispatch) => {
    const name = await AnalyticsAPI.fetchCoachName(coachOrgId);

    dispatch({
      type: 'SET_COACH_NAME',
      coachName: name
    });

    return name;
  }
};


// WEBPACK FOOTER //
// ./src/actions/analyticsActions.js